// extracted by mini-css-extract-plugin
export default {"orders__table":"OrdersPage_orders__table__RRAei","orgerRow__elem_status":"OrdersPage_orgerRow__elem_status__oOt9Q","orders__filter":"OrdersPage_orders__filter__Np7ou"};